export enum EpisodeStatus {
    Active = 0,
    Draft = 1,
    WalkInDraft = 2,
    StoredLocal = 3,
    Archived = 5,
    DraftPrescription = 6,
    Locked = 7,
    FormDraft = 8,
    PatientUploadedDocuments = 9
}
